/** Use the base identifier unless it has a known operational callsign mapping. */
export function flightPlanCallsign(homeBaseIdent: string, registration: string): string {
  if (registration === "OEXAM" || registration === "OERSY") return "";
  if (registration === "OEXXX") return "CHRI01";

  const base = homeBaseIdent ?? "";
  if (base === "H03") return "CHRI33";
  if (/^C\d+$/.test(base)) return "CHRI" + base.substring(1);
  if (/^A\d+$/.test(base)) return "ALPIN" + parseInt(base.substring(1), 10);
  return base;
}
